<template>
  <div class="retrun-kj">
    <div style="text-align: right">
      <Print :print-value="printValue" @handleOn="handleOn" />
    </div>
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="详细信息" name="first">
          <el-scrollbar>
            <el-form label-width="100px" class="">
              <el-col :span="8">
                <el-form-item v-if="form.fBillNo" label="退货单号">
                  <el-input :value="form.fBillNo" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="送货单">
                  <el-input :value="form.fCkBillNo" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="经销商">
                  <el-input :value="form.fDistributor" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="订单号">
                  <el-input :value="form.orderBillNo" readonly />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="送货单号">
                  <el-input :value="form.fCkBillNo" readonly />
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="客户名称">
                  <el-input :value="form.fCustomer" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="订单付款比例">
                  <el-input :value="form.fDeductionRatio" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="退款金额">
                  <el-input :value="total" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="退货原因">
                  <el-input
                    type="textarea"
                    :value="form.fDes"
                    readonly
                    :rows="3"
                  />
                </el-form-item>
              </el-col>
            </el-form>
            <el-table :data="form.saleRetrunEntrys">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table :data="props.row.entrys">
                    <el-table-column prop="fBatchNo" label="批号" />
                    <el-table-column
                      prop="fDate_Sc"
                      label="生产日期"
                      :formatter="dateFormat"
                    />
                    <el-table-column prop="fDate_Xd_zw" label="消毒日期" />
                    <el-table-column prop="fRetroactiveNo" label="追溯号" />
                    <el-table-column prop="fPhQty" label="送货数量" />
                    <el-table-column prop="fThQty" label="已退数量" />
                    <el-table-column prop="fKtQty" label="可退数量" />
                    <el-table-column prop="fQty" label="退货数量" />
                    <el-table-column prop="fCpQty" label="转次品数量" />
                    <el-table-column prop="fDes" label="备注" />

                  </el-table>
                </template>
              </el-table-column>
              <el-table-column label="产品编码" prop="fNumber" />
              <el-table-column label="产品名称" prop="fName" />
              <el-table-column label="规格" prop="fModel" />
              <el-table-column label="单位" prop="fUnit" />
              <el-table-column label="批号" prop="fBatchNo" />
              <el-table-column label="数量" prop="fOrderQty" />
              <el-table-column label="退货数量" prop="fQty" />
              <el-table-column label="转次品数量" prop="fCpQty" />
              <el-table-column label="单价" prop="fPrice" :formatter="currencyFormat" />
              <el-table-column label="已确认数" prop="fQty_qr" />
              <el-table-column label="退款比例(%)" prop="fDeductionRatio" />
              <el-table-column label="小计" prop="fTotal" :formatter="currencyFormat" />
            </el-table>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="确认" name="second">
          <el-form label-width="78px" style="overflow: auto">
            <el-form-item
              label="意见"
              style="margin-top: 10px"
              class="formitem"
            >
              <el-input
                v-model="form.procedureInfo.fOpinion"
                type="textarea"
                rows="4"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                :disabled="saving"
                @click="submit(1)"
              >通过</el-button>
              <el-button
                type="warning"
                :disabled="saving"
                @click="submit(2)"
              >回退</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateTimeFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
import ReturnNode from '@components/ReturnNode'
import Print from '../commonPrint/printButton'

export default {
  components: {
    ReturnNode, Print
  },
  inject: ['getMap'],
  data: function() {
    return {
      form: {
        procedureInfo: {},
        procedureMessage: [],
        saleRetrunEntrys: []
      },

      rules: {},

      activeName: 'first',
      printValue: null,
      saving: false,
      loading: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    total: function() {
      var t = this.form.saleRetrunEntrys.reduce((sum, item) => {
        return Number(sum) + Number(item.fTotal)
      }, 0)
      return t.toFixed(2)
    },
    totalRatio: function() {
      var t = this.form.saleRetrunEntrys.reduce((sum, item) => {
        return Number(sum) + Number(item.fTotal)
      }, 0)
      return (t * Number(this.form.fDeductionRatio) / 100).toFixed(2)
    }
  },
  methods: {
    submit: function(type) {
      this.$refs.form.validate(async(valid) => {
        this.form.procedureInfo.fType = type
        if (type == 2) {
          if (!this.form.procedureInfo.fOpinion) {
            this.activeName = 'second'
            this.$message.error('请填写审核意见')
            return
          }

          const h = this.$createElement
          this.form.procedureInfo.returnNode = await new Promise(
            (resolve, reject) => {
              this.$formDlg({
                title: '选择回退节点',
                formTpl: <ReturnNode name={'ReturnGoods_kj_s'}></ReturnNode>,
                formSubmit: resolve,
                width: '30%'
              })
            }
          )
        } else {
          this.form.procedureInfo.returnNode = null
          const flg = await this.$ask('是否提交?')
          if (!flg) return
        }

        this.saving = true
        this.$httpPost(
          'SaleRetrun/SaleRetrunBillForKj/SaleRetrunForKjApproval',
          {
            datalist: JSON.stringify(this.form)
          }
        )
          .then((res) => {
            if (!res.isSuccess) {
              this.$message.error(res.message)
              return
            }

            // 重新刷新页面数据
            this.$message.success(res.message)

            if (this.$route.query.ishome) {
              const tabName = this.$store.state.tabName
              this.getMap(tabName)
              this.$router.push({ path: '/' })
            } else {
              const tabName = this.$store.state.tabName
              this.getMap(tabName)
              this.$router.push({ path: '/saleRetrun/saleRetrunBillForKJ' })
            }

            // if (res.datalist) this.refresh(res.datalist);
          })
          .finally(() => (this.saving = false))
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        throw '不可能到这里'
      }

      this.loading = true
      const res = await this.$httpPost(
        'SaleRetrun/SaleRetrunBillForKj/GetSaleRetrunBillForKj',
        { fid: id }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
    },
    dateTimeFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    currencyFormat: function(row, column, cellValue) {
      const val = cellValue
      if (val == undefined) {
        return ''
      }
      return Number(val).toFixed(2)
    },
    handleOn: function() {
      // console.log(this.form, 'this.form')
      this.printValue = this.form.fid
    }
  }
}
</script>

<style lang="less" scoped>
.wlinfo {
  .el-input,
  .el-select,
  .el-autocomplete,
  .el-textarea {
    width: 20% !important;
  }
}
</style>
<style lang="less">
.retrun-kj {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
}
</style>
